FD.CONTROL = (function ($, me) {
    'use strict';

    var child = me.CONTROL || {};

    /* ========================================================================
     *  private vars
     * ========================================================================
    */

    //  element
    var ELEM = '[data-fd="select"]';
    var eventsAreSet = false;

    //  defaults
    var defaults = {
        useparent: true,
        parentid: -1,
        callbackprefix: 1,
        tag: 95,
        value: '',
        noedit: false,
        clearonload: false,
        initial: null
    };



    /* ========================================================================
     *  private methods
     * ========================================================================
    */


    //  set events
    function setEvents() {
        var NAMESPACE = me.getUID('CTRL_');

        //  set event
        $(document).off('change', ELEM).on('change.' + NAMESPACE, ELEM, changeSelect);
    }


    //  get select
    function getSelect(wireEvent, container) {
        var list = '';

        //  set list
        if (container !== null) {
            if (typeof container === 'string') container = $(container);
            list = container.find(ELEM);
        } else {
            list = $(ELEM);
        }


        //  wire events
        if (wireEvent && !eventsAreSet) {
            setEvents();
            eventsAreSet = true;
        }


        //  bail
        if (list.length === 0) {
            return;
        }


        //  element
        list.each(function (i, e) {
            var elem = $(e);

            //  set options
            var options = $.extend({}, defaults, elem.data());

            //  set elem data
            me.setControlItemOptions(elem, options);

            //  set data
            elem.data(options);

            if (options.clearonload) {
                if (options.initial) {
                    elem.val(options.initial);
                } else {
                    elem.val(elem.find('option')[0].value);
                }
                options.clearonload = false;
                elem.data('clearonload', false).attr('data-clearonload', false);
            }

            //  no edit
            if (options.noedit) {
                elem.prop('disabled', true);
            }
        });
    }


    //  change select
    function changeSelect() {
        var e = $(this);
        
        e.data().element = e;

        var data = e.data();
        var val = e.val();
        var initial = data.value;

        e.data().value = val;

        if (data.noedit) {
            return;
        }

        e.data(data);

        //  callback
        data = e.data();
        me.setCallBackFromData(e, { e: data.element, value: data.value, tag: data.tag, parentid: data.parentid, initial: initial });
    }


    /* ========================================================================
     *  public methods
     * ========================================================================
    */

    
    //  set select
    child.setSelect = function (wireEvent, container) {
        getSelect(wireEvent, container);
    };


    /* ========================================================================
     *  return
     * ========================================================================
    */
    return child;
}(jQuery, FD));